import type { Dictionary } from "@reduxjs/toolkit";
import { selectActiveWorkspaceId } from "@somewear/auth";
import type { IDevice } from "@somewear/model";
import { getDictionaryValue, selectEcho } from "@somewear/model";
import { createSelector } from "reselect";

import type { DeviceState } from "./device.state";
import { selectAllDevices } from "./devicesSlice";

export const selectDevicesForActiveWorkspace = createSelector(
	[selectAllDevices, selectActiveWorkspaceId],
	(devices, workspaceId) => {
		return devices.filter((device) => device.workspaceId === workspaceId);
	},
);

export const isBorrowedDevice = (
	deviceOrganizationId?: string,
	workspaceOrganizationId?: string,
	activeOrganizationId?: string,
) => {
	if (activeOrganizationId === undefined) return false;
	if (deviceOrganizationId === undefined) return false;
	if (deviceOrganizationId === activeOrganizationId) return false;

	return workspaceOrganizationId === activeOrganizationId;
};

export const selectDevicesByUserId = createSelector([selectAllDevices], (devices) => {
	const deviceDict: Dictionary<IDevice> = {};
	devices.forEach((device) => {
		if (device.userAccountId === undefined) return;
		deviceDict[device.userAccountId] = device;
	});
	return deviceDict;
});

export const selectDeviceByUserId = createSelector(
	[selectDevicesByUserId, selectEcho<string, DeviceState>],
	(devices, userId) => {
		return getDictionaryValue(devices, userId);
	},
);
